import styles from './SkipLink.module.css'

/** First tab stop on the page — jumps keyboard users past the nav. */
export function SkipLink() {
  return (
    <a href="#main" className={styles.skip}>
      Skip to main content
    </a>
  )
}
